import { createConfirmPrefill, prefillValue } from './shared';

const getProfilePrefillName = prefillValue('fullName');
const getProfilePrefillDob = prefillValue('dateOfBirth');
const getProfilePrefillSsn = prefillValue('ssn');

export const hasProfilePrefill = formData => {
  const fullName = getProfilePrefillName(formData);
  return Boolean(
    fullName?.first &&
      fullName?.last &&
      getProfilePrefillDob(formData) &&
      getProfilePrefillSsn(formData),
  );
};

// no confirm key: the page is read-only, so there is no edit path
export const {
  showPrefill: showSponsorPrefill,
  showEntry: showSponsorEntry,
  sync: syncSponsorPrefill,
} = createConfirmPrefill({
  appliedKey: 'view:sponsorPrefillApplied',
  hasPrefill: hasProfilePrefill,
  fields: {
    sponsorName: getProfilePrefillName,
    sponsorDob: getProfilePrefillDob,
    sponsorSsn: getProfilePrefillSsn,
  },
});
